import {
  createLabeledEnum,
  type InferLabeledEnum,
} from "../utils/labeled-enum";

export const companyStatuses = createLabeledEnum({
  // NORMAL: "Normal",
  Aktiv: "Aktiv / Normal",
  UNDERTVANGSOPLØSNING: "Under Tvangsopløsning",
  UNDERFRIVILLIGLIKVIDATION: "Under Frivillig Likvidation",
  UNDERKONKURS: "Under Konkurs",
  UNDERREKONSTRUKTION: "Under Rekonstruktion",
  UNDERREASSUMERING: "Under Reassumering",
  Ophørt: "Ophørt",
  TVANGSOPLØST: "Tvangsopløst",
  OPLØSTEFTERKONKURS: "Opløst Efter Konkurs",
  OPLØSTEFTERFUSION: "Opløst Efter Fusion",
  OPLØSTEFTERFRIVILLIGLIKVIDATION: "Opløst Efter Frivillig Likvidation",
  OPLØSTEFTERERKLÆRING: "Opløst Efter Erklæring",
  OPLØSTEFTERSPALTNING: "Opløst Efter Spaltning",
  SLETTET: "Slettet",
});

export type CompanyStatus = InferLabeledEnum<typeof companyStatuses>;

export const companyTypes = [
  { label: "Aktieselskab", value: 60 },
  { label: "Amtskommune", value: 240 },
  { label: "Andelsselskab (-forening)", value: 130 },
  { label: "Andelsselskab (-forening) begr. ansvar", value: 140 },
  { label: "Anden udenlandsk virksomhed", value: 210 },
  { label: "Anpartsselskab", value: 80 },
  { label: "Dødsbo", value: 20 },
  { label: "Enkeltmandsvirksomhed", value: 10 },
  { label: "Erhvervsdrivende fond", value: 100 },
  { label: "Europæisk Økonomisk Firmagruppe", value: 160 },
  { label: "Filial af udenlandsk virksomhed m.b.a.", value: 190 },
  { label: "Filial af udenlandsk A/S eller K/S", value: 170 },
  { label: "Filial af udenlandsk ApS eller selskab", value: 180 },
  { label: "Folkekirkelige Institutioner", value: 260 },
  { label: "Fonde og andre selvejende institutioner", value: 90 },
  { label: "Forening", value: 110 },
  { label: "Forening eller selskab med begr. ansvar", value: 150 },
  { label: "Forening med begrænset ansvar", value: 152 },
  { label: "Frivillig forening", value: 115 },
  { label: "Interessentskab", value: 30 },
  { label: "Iværksætterselskab", value: 81 },
  { label: "Kommanditaktieselskab / Partnerselskab", value: 70 },
  { label: "Kommanditselskab", value: 40 },
  { label: "Medarbejderinvesteringsselskab", value: 45 },
  { label: "Partrederi", value: 50 },
  { label: "Personlig ejet Mindre Virksomhed", value: 15 },
  { label: "Primærkommune", value: 250 },
  { label: "Region", value: 245 },
  { label: "SCE-selskab", value: 195 },
  { label: "Selskab med begrænset ansvar", value: 151 },
  { label: "Selvstændig offentlig virksomhed", value: 235 },
  { label: "Statslig administrativ enhed", value: 230 },
  { label: "Særlig Finansiel virksomhed", value: 285 },
  { label: "Uoplyst virksomhedsform", value: 990 },
  { label: "Øvrige virksomhedsformer", value: 280 },
];

export const companyTypesMap = new Map<number, string>(
  companyTypes.map((type) => [type.value, type.label]),
);
